import React from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { isEmpty } from 'lodash';
import ErrorTooltip from '../ErrorTooltip';

const InputFieldWrapper = ({
  errors,
  placeholderMessage,
  value,
  onChange,
  intl,
}) => {
  // cast to boolean, determine whether field has errors
  let hasErrors = !isEmpty(errors);

  let inputClassnames = classnames({ error: hasErrors });

  return (
    <div className="control-group">
      <div className="controls">
        <input
          className={inputClassnames}
          type="text"
          placeholder={intl.formatMessage(
            placeholderMessage.message,
            placeholderMessage.values
          )}
          value={value}
          onChange={onChange}
        />
        {hasErrors &&
          errors.map((error) => (
            <div
              style={{
                display: 'inline-block',
                marginTop: '-20px',
                height: '20px',
              }}
            >
              <ErrorTooltip key={error} error={error} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default injectIntl(InputFieldWrapper);
